module.exports = __webpack_public_path__ + "img/phase3.85a7b8ed.png";